import { connect } from "react-redux";
import sortBy from "lodash/sortBy";

import SelectionFooterSubParts from "../selectionWindow/selectionFooterSubParts";
import Analytics from "../../analytics";
import {getCurrentLayout} from '../appLayout';
import {
  changeActivePartRelatedItemIndex,
  setQtActiveCategory,
  toggleSelectionWindow
} from "../../actions/actionFunctions";
import {changeQTRoutePath, changeRoutePath} from "../../misc/changeRoutePath";
import $ from "jquery";

class ShoppingCartFooterSubParts extends SelectionFooterSubParts {

  componentDidMount() {
    this.setRelatedItems(this.props);
    if (this.footerList) {
      this.footerList.addEventListener("scroll", this.handleFooterListScroll);
      // $(this.footerList).animate({scrollLeft: this.footerList.scrollWidth}, 500);
      setTimeout(() => {
        if (this.footerList) {
          $(this.footerList).animate({scrollLeft: this.footerList.scrollWidth}, 500);
        }
      }, 0)
    }
  }

  componentWillUnmount() {
    if (this.footerList) {
      this.footerList.removeEventListener("scroll", this.handleFooterListScroll);
    }
    super.componentWillUnmount();
  }

  setSelectionGroup = () => {
    this.props.toggleSelectionWindow(false, this.props.layoutParts[0]);
    return Promise.resolve();
  };

  handleFooterButtonClick = (index) => {
    Analytics.sendClickEvent('go-to-materials-page');
    const layout = getCurrentLayout();
    if (layout.qtCategories) {
      const firstCatName = layout.qtCategories[0].name;
      this.props.setQtActiveCategory(firstCatName);
      changeQTRoutePath(firstCatName, index);
    } else {
      this.setSelectionGroup()
        .then(() => {
          changeRoutePath(this.props.activePart, index, false);
        })
    }
    this.props.changeActivePartRelatedItemIndex(index);
  };

  setRelatedItems = () => {
    const layout = getCurrentLayout();
    if (layout.qtCategories) {
      const qtActiveCategory = sortBy(layout.qtCategories, qtCategory => qtCategory.order)[0];
      this.setState({
        relatedItems: qtActiveCategory.subParts
      });
    } else {
      const firstKey = Object.keys(layout.parts)[0];
      this.setState({
        relatedItems: layout.parts[firstKey].subParts(false)
      });
    }
  };

  render() {
    return this.getSubPartsList(true);
  }
}

const mapStateToProps = (store) => {
  const {windowWidth, visualizersLoaded, networkConnection, visualizerIsChanging} = store.serverState;

  return {
    /*** subparts ***/
    windowWidth,
    selectionFeatureInfo: store.selectionState.selectionFeatureInfo,
    cartItems: store.cartState.cartItems,
    activeFeature: store.selectionState.activeFeature,
    updateFeatureCount: store.selectionState.updateFeatureCount,
    activePartRelatedItemIndex: store.selectionState.activePartRelatedItemIndex,
    qtActiveCategory: store.qtState.qtActiveCategory,
    visualizersLoaded,
    networkConnection,
    visualizerIsChanging,
    /*** subparts end ***/
    layoutParts: store.stepsState.layoutParts
  };
};

export default connect(mapStateToProps, {
  changeActivePartRelatedItemIndex,
  setQtActiveCategory,
  toggleSelectionWindow
})(ShoppingCartFooterSubParts);
